import { render } from "./PollResultDetails.vue?vue&type=template&id=4840ede0&scoped=true"
import script from "./PollResultDetails.vue?vue&type=script&lang=js"
export * from "./PollResultDetails.vue?vue&type=script&lang=js"

import "./PollResultDetails.vue?vue&type=style&index=0&id=4840ede0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4840ede0"]])

export default __exports__